import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Slider } from "antd";
import { PageLayout, PageLayoutHeader } from "Components/PageLayout";
import BackgroundSetting from "Components/BackgroundSetting";
import { langCheck, GetQuery, cardIntervalFormat, getRatio, setBodyClass, setNccFontSize, setNccFormStyle, setInsideTab, setNccTableStyle, diffBetweenObjects, getWindow } from "Pub/js/utils.js";
import subjectDefaultData from "Pub/js/subjectDefaultData";
import Appicon from "Components/Appicon";
import { setStore } from "Pub/js/storageUtils";
import { GRID_COLS, initDesktopApp } from "../NewHome/utilService";
import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";
import subjectIcons from "Pub/js/subjectIcons";
import { setNccFont, changeBgState } from "Store/appStore/action";
import { getBackgroundStyle } from "Pub/js/backgroundImg";
import platform from "Pub/js/platform";
import selectIcon from 'Assets/images/select-icon.svg';
import { initTemplate, searchId, getDesktopPreviewData, tableId, formId } from './initTemplate';
import GridLayout from '../NewHome/GridLayout';
import withDragDropContext from "Pub/js/withDragDropContext";
import { SizeMe } from "react-sizeme";
import './index.less';
import "../../pages/NewHome/index.less"; // 为了解决工作桌面预览时能响应 nc-workbench-home-container 该类下的应用部件样式
import { cloneDeep, remove, get } from "lodash";
import { Link, Element } from "react-scroll";
const { toast, createPage } = platform;
const { NCRadio, NCDiv, NCButton, NCTooltip, NCModal, NCFormControl, NCInputNumber, NCCheckbox, NCHotKeys } = platform.base;
const { Refer } = platform.high;
const { ReferLoader } = Refer;
const {
    colorMap,
    bgImgArr,
    bgColorMap,
    defaultLight,
    getColorArr,
    defaultFormTitleColor,
    defaultBackgroundObject,
    getBgColorArr
} = subjectDefaultData;
import { getBackgroundObject } from "../CompanyStyleSetting/common";

import ThemeColor from 'Components/ThemeColor';
import ColorPicker from 'Components/ColorPicker';
import { setVarsByThemeName } from 'Pub/js/theme/index';
import WatermarkSettingPanel from "./WatermarkSetting/WatermarkSettingPanel";
import Watermark from "./Watermark";
import NavBar from "../../layout/NavBar";
import dropIcon from '../../assets/images/drop.svg'; // 模拟内部页签栏dom需要的图标
import { MarkType_Text } from '../Customize/WatermarkSetting/common';
import { getLanguageMetas } from 'Pub/js/getMulti';

const scrollLinkActiveClass = 'active';
const scrollLinkDuration = 300;
const scrollLinkOffset = 0;
const ratio = getRatio();
const isNumber = value => {
    return !isNaN(Number(value));
};
const DefaultSettings = { // 默认值
    icon: '', // 图标风格
    tabletype: 'compact', // 行高设置
    crossCheck: false, // 斑马线
    cuttingCheck: true, // 纵向分割线
    fontSize: 'small', // 字号
    distance: '8', // 卡片间隔
    pagewidth: ratio === 150 ? 'adaptive' : 'fixed', // 桌面宽度 
    rowcheckedbutton: 'rowCheckFixed', // 行操作按钮
    inputdataformat: false, // 字段录入时保持数据格式
    tabstyle: 'inside', // 页签模式
    formupdownstyle: false, // 表单上下模式
    formunderlinestyle: false, // 表单下划线模式
    formtitlecolor: defaultFormTitleColor, // 表单标题颜色
    color: defaultLight, // 主题色
    name: '默认浅', // 主题名称
    pk_customtheme: undefined, // 自定义主题主键
    bdtype: 'color', // 背景类型
    bdcolor: 'gray', // 背景色
    bdpicture: 'backgroundImg1', // 背景图
    bdpicdim: 0, // 背景模糊度
    tablehdbgcolor: 'light', // 表头背景色 light norm dark
    selectedrowcolor: 'light', // 选中行背景色 light norm dark
}
class SubjectSetting extends Component {
    constructor(props) {
        super(props);
        props.subjectRef && props.subjectRef(this);
        this.state = {
            checkedColor: DefaultSettings.color,
            checkedIcon: DefaultSettings.icon,
            checkedTable: DefaultSettings.tabletype, // 表格设置  standard 标准   compact 紧凑  loose 宽松
            colorArr: getColorArr(),
            bgImgArr: bgImgArr,
            bgColorArr: getBgColorArr(),
            iconArr: [
                {
                    key: 0,
                    type: "", //默认版
                    name: langCheck("0000PUB-000357") /* 国际化处理： 默认版*/,
                    defaultShow: DefaultSettings.icon === '',
                    fieldid: "defaultIcon",
                },
                {
                    key: 1,
                    type: "youth", //青春版
                    name: langCheck("0000PUB-000347") /* 国际化处理： 青春版*/,
                    defaultShow: DefaultSettings.icon === 'youth',
                    fieldid: "youthIcon",
                },
                {
                    key: 2,
                    type: "business", //商务版
                    name: langCheck("0000PUB-000348") /* 国际化处理： 商务版*/,
                    defaultShow: DefaultSettings.icon === 'business',
                    fieldid: "businessIcon",
                },
                {
                    key: 3,
                    type: "industry", //工业风
                    name: langCheck("0000PUB-000349") /* 国际化处理： 工业风*/,
                    defaultShow: DefaultSettings.icon === 'industry',
                    fieldid: "industryIcon",
                },
                {
                    key: 4,
                    type: "simple", //简约版
                    name: langCheck("0000PUB-000350") /* 国际化处理： 简约版*/,
                    defaultShow: DefaultSettings.icon === 'simple',
                    fieldid: "simpleIcon",
                },
            ],
            desktopArr: [
                {
                    key: 0,
                    type: "adaptive", //
                    name: langCheck("0000PUB-000411") /* 国际化处理： 自适应*/,
                    defaultShow: DefaultSettings.pagewidth === "adaptive",
                    fieldid: "adaptive",
                },
                {
                    key: 1,
                    type: "fixed", //
                    name: langCheck("0000PUB-000412") /* 国际化处理： 固定宽度*/,
                    defaultShow: DefaultSettings.pagewidth === "fixed",
                    fieldid: "fixed",
                },
            ],
            fontSizeArr: [
                {
                    key: 0,
                    type: "small", //
                    name: langCheck("0000PUB-000373") /* 国际化处理： 小*/,
                    defaultShow: DefaultSettings.fontSize === 'small',
                    fieldid: "small",
                },
                {
                    key: 1,
                    type: "medium", //
                    name: langCheck("0000PUB-000374") /* 国际化处理： 中*/,
                    defaultShow: DefaultSettings.fontSize === 'medium',
                    fieldid: "medium",
                },
                {
                    key: 2,
                    type: "large", //
                    name: langCheck("0000PUB-000375") /* 国际化处理： 大*/,
                    defaultShow: DefaultSettings.fontSize === 'large',
                    fieldid: "large",
                },
                {
                    key: 3,
                    type: "custom", //
                    name: langCheck("0000PUB-000490") /* 国际化处理： 自定义*/,
                    defaultShow: DefaultSettings.fontSize === 'custom',
                    fieldid: "custom",
                },
            ],
            tabsArr: [
                {
                    key: 0,
                    type: "inside",
                    name: langCheck("0000PUB-000550") /* 国际化处理： 内部页签*/,
                    defaultShow: DefaultSettings.tabstyle === 'inside',
                    fieldid: "inside",
                    icon: "insideTabIcon"
                },
                {
                    key: 1,
                    type: "outside",
                    name: langCheck("0000PUB-000551")/* 国际化处理： 浏览器页签*/,
                    defaultShow: DefaultSettings.tabstyle === 'outside',
                    fieldid: "outside",
                    icon: "outsideTabIcon"
                },
            ],
            tableSettingArr: [
                {
                    key: 0,
                    type: 'compact',
                    fieldid: 'compact',
                    name: langCheck("0000PUB-000351") /* 国际化处理： 紧凑*/,
                    defaultShow: DefaultSettings.tabletype === 'compact',
                },
                {
                    key: 1,
                    type: 'standard',
                    fieldid: 'standard',
                    name: langCheck("0000PUB-000352") /* 国际化处理： 标准*/,
                    defaultShow: DefaultSettings.tabletype === 'standard',
                },
                {
                    key: 2,
                    type: 'loose',
                    fieldid: 'loose',
                    name: langCheck("0000PUB-000353") /* 国际化处理： 宽松*/,
                    defaultShow: DefaultSettings.tabletype === 'loose',
                },
            ],
            fontSize: DefaultSettings.fontSize, //默认小字号
            crossCheck: DefaultSettings.crossCheck, //斑马线
            cuttingCheck: DefaultSettings.cuttingCheck, //纵向分割线
            distance: DefaultSettings.distance, // 卡片间隔 ncc2207改为8/12/16/20/24px (ncc2111历史数据：tight 紧凑 moderate 适中 relax 宽松)
            pagewidth: DefaultSettings.pagewidth, //桌面宽度
            isStyleSetting: !!this.props.title, // true为企业风格设置
            rowcheckedButton: DefaultSettings.rowcheckedbutton, // rowCheckFixed 固定显示  suspension 默认悬浮显示
            inputdataformat: DefaultSettings.inputdataformat, //字段录入时保持数据格式
            customTheme: { // 自定义主题
                show: false,
                // name: '自定义',
                // color: '#BF381A',
                // pk_customtheme
            },
            customFontSize: '12', // 自定义字号
            formUpdownArr: [
                {
                    key: 0,
                    type: false,
                    name: langCheck("0000PUB-000665") /* 国际化处理： 左右*/,
                    defaultShow: DefaultSettings.formupdownstyle === false,
                    fieldid: "form-left-right",
                    icon: 'formleftright',
                },
                {
                    key: 1,
                    type: true,
                    name: langCheck("0000PUB-000666") /* 国际化处理： 上下*/,
                    defaultShow: DefaultSettings.formupdownstyle === true,
                    fieldid: "form-up-down",
                    icon: 'formupdown',
                }
            ],
            formUnderlineArr: [
                {
                    key: 0,
                    type: false,
                    name: langCheck("0000PUB-000667") /* 国际化处理： 输入框*/,
                    defaultShow: DefaultSettings.formunderlinestyle === false,
                    fieldid: "form-input",
                    icon: 'forminput',
                },
                {
                    key: 1,
                    type: true,
                    name: langCheck("0000PUB-000668") /* 国际化处理： 下划线*/,
                    defaultShow: DefaultSettings.formunderlinestyle === true,
                    fieldid: "form-underline",
                    icon: 'formunderline',
                }
            ],
            formupdownstyle: DefaultSettings.formupdownstyle,
            formunderlinestyle: DefaultSettings.formunderlinestyle,
            formtitlecolor: DefaultSettings.formtitlecolor,
            watermarkSetting: { // 水印设置配置
                show: false,
            },
            activeTab: 'globalSetting',
            tabstyle: DefaultSettings.tabstyle,
            tablehdbgcolor: DefaultSettings.tablehdbgcolor,
            selectedrowcolor: DefaultSettings.selectedrowcolor,
            themeConf: {
                color: DefaultSettings.color,
                name: DefaultSettings.name,
                pk_customtheme: DefaultSettings.pk_customtheme,
            },
            nvigapic: null
        };
        this.instantiationKey = Date.now();
        this.multiLangOptions = getLanguageMetas();
    }

    componentDidMount() {
        this.getUserChecked().then(allowClick => {
            if (!this.state.isStyleSetting) { // 个性化设置
                this.setState({ allowClick });
                this.getDefaultColor().then(this.setSubjectSettings);
            } else { // 企业风格设置
                // 传入usermodify 去判断头部导航是否实时生效
                this.setState({ usermodify: allowClick });
            }
        });

        this.computePreviewScale();
        setTimeout(() => {
            this.getItemAreaStyle();
        })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.styleSettingName) {
            // 企业风格设置走这个
            const { styleSettingName, companyStyleSettingObj } = nextProps;
            const { groupChecked, backgroundObject } = companyStyleSettingObj;
            let allowClick = true;
            if (styleSettingName === 'global') {
                allowClick = true;
            } else if (styleSettingName === 'group' && groupChecked) {
                allowClick = true;
            } else {
                allowClick = false;
            }
            this.setState({
                allowClick
            });
            this.setBgColorArr(backgroundObject);
        } else {
            if (nextProps.globalTheme.color !== this.state.themeConf.color) {
                // console.log('个性化设置-用户在侧拉更新了主题');
                this.setState({
                    checkedColor: nextProps.globalTheme.color,
                    themeConf: { ...nextProps.globalTheme }
                }, () => {
                    this.setPreviewTheme();
                })
            }
        }
        //个性化设置 右侧背景实时预览
        if (JSON.stringify(nextProps.backgroundState) !== "{}" && !nextProps.styleSettingName) {
            this.setBgColorArr(nextProps.backgroundState);
        }
    }

    setSubjectSettings = settings => {
        this.backSettingData = _.cloneDeep(settings);
        let mergeData;
        if (settings.isDefault) {
            mergeData = { ...DefaultSettings };
        } else {
            mergeData = { ...DefaultSettings, ...settings };
        }
        this.setData(mergeData);
        const backgroundObject = getBackgroundObject(mergeData);
        this.props.changeBgState(backgroundObject); // 初始化更新
    }

    updateActiveTab = tab => {
        const { activeTab } = this.state;
        if (activeTab !== tab) {
            const linkItems = this.scrollLinkRef.querySelectorAll('.link-item');
            linkItems.forEach(item => {
                if (item.getAttribute('tabid') === tab) {
                    item.classList.add(scrollLinkActiveClass);
                } else {
                    item.classList.remove(scrollLinkActiveClass);
                }
            })
            this.setState({
                activeTab: tab
            });
        }
    }

    computePreviewScale = () => {
        const previewRect = this.previewRef.getBoundingClientRect();
        const scale = previewRect.width / window.innerWidth;
        this.previewRef.style.setProperty('zoom', scale);
        this.previewScale = scale;
    }

    // 初始化设置企业风格数据，由父组件调用
    setStyleSettings = (styleSettings, watermarkSetting = { show: false }) => {
        this.backSettingData = _.cloneDeep(styleSettings);
        this.setData({ ...DefaultSettings, ...styleSettings });
        this.setState({
            watermarkSetting
        });
    }

    setBgColorArr = backgroundObject => {
        // 修改背景设置状态
        let { bgColorArr } = this.state;
        let { bgColor } = backgroundObject;
        let newBgColor = '';
        if (bgColorMap[bgColor]) {
            newBgColor = bgColorMap[bgColor];
            bgColorArr.map(item => {
                item.defaultShow = false;
                if (item.name === bgColor) {
                    item.defaultShow = true;
                    item.color = newBgColor;
                }
                return item;
            });
            const sketchObj = {
                key: 4,
                color: "linear-gradient(134deg, #CC6767 0%, #3F55F2 21%, #4BCE39 43%, #FFE364 70%, #EC4444 100%)",
                name: 'sketch',
                defaultShow: false,
                fieldid: "sketchBgColor",
            };
            bgColorArr[bgColorArr.length - 1] = sketchObj;
        } else {
            newBgColor = bgColor;
            bgColorArr.map(item => {
                item.defaultShow = false;
                if (item.name === 'sketch') {
                    item.defaultShow = true;
                    item.color = newBgColor;
                }
                return item;
            });
        }
    }
    
    // setState接口数据
    /**
     * 
     * @param {*} data  数据
     */
    setData = (data) => {
        let { colorArr, iconArr, tabsArr, tableSettingArr, customFontSize, formUpdownArr, formUnderlineArr } = this.state;
        let {
            color,
            name,
            icon,
            tabletype,
            crossCheck,
            cuttingCheck,
            fontSize,
            pagewidth,
            distance,
            rowcheckedbutton,
            inputdataformat,
            customColors,
            pk_customtheme,
            tabstyle,
            formupdownstyle,
            formunderlinestyle,
            formtitlecolor,
            tablehdbgcolor,
            selectedrowcolor,
            nvigapic,
        } = data;
        customColors && (colorArr = getColorArr().concat(customColors)); // 合并自定义和预置的
        color = color === "#F1F1F1" ? defaultLight : color; // 兼容旧的数据
        colorArr.forEach(e => {
            e.defaultShow = e.pk_customtheme === pk_customtheme && e.color == color;
        });
        if (icon) {
            iconArr.forEach(e => {
                e.defaultShow = e.type === icon;
            });
        }
        if (tabstyle) {
            tabsArr.forEach(e => {
                e.defaultShow = e.type === tabstyle;
            })
        }
        if (tabletype) {
            tableSettingArr.forEach(e => {
                e.defaultShow = e.type === tabletype;
            });
        }
        if (formupdownstyle) {
            formUpdownArr.forEach(e => {
                e.defaultShow = e.type === formupdownstyle;
            });
        }
        if (formunderlinestyle) {
            formUnderlineArr.forEach(e => {
                e.defaultShow = e.type === formunderlinestyle;
            });
        }
        if (isNumber(fontSize)) {
            customFontSize = fontSize;
        }

        this.setState({
            colorArr,
            iconArr,
            formUpdownArr,
            formUnderlineArr,
            tabsArr,
            tableSettingArr,
            // 上面的都是为了更新defaultShow
            checkedColor: color,
            checkedIcon: icon,
            checkedTable: tabletype,
            crossCheck,
            cuttingCheck,
            fontSize,
            pagewidth,
            distance,
            rowcheckedButton: rowcheckedbutton,
            inputdataformat,
            customFontSize,
            formupdownstyle,
            formunderlinestyle,
            formtitlecolor,
            tabstyle,
            tablehdbgcolor,
            selectedrowcolor,
            themeConf: {
                color,
                name,
                pk_customtheme,
            },
            nvigapic
        }, () => {
            this.setPreviewTheme();
        });
    };

    setPreviewTheme() {
        const { tablehdbgcolor, selectedrowcolor, themeConf } = this.state;
        const { pk_customtheme, color } = themeConf;
        const tableTheme = { tablehdbgcolor, selectedrowcolor };
        const themeType = pk_customtheme ? 'mixin' : colorMap[color];
        setVarsByThemeName(`initial-${themeType}`, color, `.subjectsetting-${this.instantiationKey} .previewPic`);
        setBodyClass({ themeType, rootElement: this.subjectSettingRef.querySelector('.previewPic'), dealWithPlatform: true });
        // 设置platform的主题变量
        window.setVarsByThemeName(`initial-${themeType}`, color, { selector: `.subjectsetting-${this.instantiationKey} .previewPic`, tableTheme });
    }

    // 是否允许个人修改主题皮肤和背景设置
    getUserChecked = () => {
        return new Promise(resolve => {
            Ajax({
                url: "/nccloud/platform/appregister/getcorpstylemodify.do",
                data: {},
                noNeedShowError: true,
                success: ({ data }) => {
                    if (data.success) {
                        resolve(data.data.usermodify);
                    }
                },
            });
        });

    }
    /**
     * 个性化设置 获取存取颜色
     */
    getDefaultColor = () => {
        return new Promise(resolve => {
            Ajax({
                url: "/nccloud/platform/appregister/querythemecolor.do",
                data: {},
                loading: true,
                noNeedShowError: true,
                success: ({ data }) => {
                    if (data.success && data.data) {
                        resolve(data.data);
                    }
                },
            });
        })
    };
    /**
     * 应用-更换主题-个性化设置
     */
    getSubject = () => {
        const { isStyleSetting } = this.state;
        const { companyStyleSettingFn } = this.props;
        const currentData = this.getCurrentData();
        const diffData = diffBetweenObjects(currentData, this.backSettingData);
        // console.log('差异化数据', diffData);
        if (isStyleSetting) { // 企业风格设置
            if (this.watermarkPanel && !this.watermarkPanel.validateWatermarkSetting(diffData.watermarkSetting)) {
                return;
            }
            const { usermodify } = this.state;
            // 传入usermodify 去判断切换主题是否实时生效
            companyStyleSettingFn({ usermodify, styleSettings: diffData });
        } else { // 个性化设置
            this.subjectSetting(diffData);
        }
    };

    getCurrentData = () => {
        const {
            isStyleSetting,
            checkedColor,
            checkedIcon,
            watermarkSetting,
            checkedTable,
            crossCheck,
            cuttingCheck,
            fontSize,
            distance,
            pagewidth,
            rowcheckedButton,
            inputdataformat,
            tabstyle,
            formupdownstyle,
            formunderlinestyle,
            formtitlecolor,
            tablehdbgcolor,
            selectedrowcolor,
        } = this.state;
        const applyCommonData = {
            icon: checkedIcon, // 图标风格
            tabletype: checkedTable, // 行高设置
            crossCheck, // 斑马线
            cuttingCheck, // 纵向分割线
            fontSize, // 字号
            distance, // 卡片间隔
            pagewidth, // 桌面宽度 
            rowcheckedbutton: rowcheckedButton, // 行操作按钮
            inputdataformat, // 字段录入时保持数据格式
            tabstyle, // 页签模式
            formupdownstyle, // 表单上下模式
            formunderlinestyle, // 表单下划线模式
            formtitlecolor, // 表单标题颜色
            tablehdbgcolor, // 表头背景色
            selectedrowcolor, // 选中行背景色
        };
        let applyOtherData = {};
        if (isStyleSetting) { // 企业风格设置
            const { backgroundObject, data } = this.props.companyStyleSettingObj;
            const { pk_customtheme, name } = data;
            const { bdtype, bgColor, blurNumber, bgImg } = backgroundObject;
            applyOtherData = {
                color: checkedColor,
                name,
                pk_customtheme,
                bdtype,
                bdcolor: bgColor,
                bdpicture: bgImg,
                bdpicdim: blurNumber,
                watermarkSetting
            }
        } else { // 个性化设置
            const { themeConf } = this.state;
            const { bdtype, bgColor, blurNumber, bgImg } = this.props.backgroundState;
            applyOtherData = {
                ...themeConf,
                bdtype,
                bdcolor: bgColor,
                bdpicture: bgImg,
                bdpicdim: blurNumber,
            }
        }
        applyOtherData.backpic = null; // 自定义背景图（需要以 backpic 传给后台）
        if (applyOtherData.bdtype === 'pic' && applyOtherData.bdpicture.includes('base64')) {
            applyOtherData.backpic = applyOtherData.bdpicture;
            applyOtherData.bdpicture = defaultBackgroundObject.bgImg;
        }
        if (applyOtherData.bdtype === 'color' && applyOtherData.bdpicture.includes('base64')) {
            applyOtherData.bdpicture = defaultBackgroundObject.bgImg;
        }
        return {
            ...applyCommonData,
            ...applyOtherData
        }
    }

    onApply() {
        this.getSubject();
    }

    // 个性化设置接口
    subjectSetting = (settingDatas) => {
        const ajaxData = {
            defaultshow: true,
            checked: true,
            ...settingDatas
        };
        Ajax({
            url: "/nccloud/platform/appregister/addthemecolor.do",
            data: ajaxData,
            info: {
                name: langCheck("0000PUB-000258") /* 国际化处理： 主题设置*/,
                action: langCheck("0000PUB-000340"), /* 国际化处理： 回写主题设置*/
            },
            noNeedShowError: true,
            success: ({ data }) => {
                if (data.success) {
                    const {
                        checkedColor,
                        distance,
                        pagewidth,
                        formupdownstyle,
                        formunderlinestyle,
                        formtitlecolor,
                        checkedIcon,
                        fontSize,
                        tabstyle,
                    } = this.state;
                    // 字体
                    this.props.setNccFont(setNccFontSize(fontSize));

                    // 桌面
                    const nccCardlAndDesktop = {
                        cardInterval: distance, //卡片间隔
                        pagewidth, //桌面宽度
                    };
                    window.nccCardlAndDesktop = nccCardlAndDesktop;
                    setStore("nccCardlAndDesktop", nccCardlAndDesktop);

                    // 页签模式
                    setInsideTab(tabstyle);

                    // 主题
                    const nccColor = colorMap[checkedColor];
                    setBodyClass({ themeType: nccColor });
                    window.nccColor = nccColor;
                    setStore("nccColor", nccColor);

                    // 图标
                    window.nccIcon = checkedIcon;
                    setStore("nccIcon", checkedIcon);

                    // 表单
                    setNccFormStyle({
                        formupdownstyle,
                        formunderlinestyle,
                        formtitlecolor,
                    });

                    // 表格
                    setNccTableStyle(this.getTableStyle());

                    Notice({
                        status: "success",
                        msg: langCheck('0000PUB-000427'), /* 国际化处理： 应用成功*/
                    });
                    
                    // 应用成功之后更新备份数据，下次才能对比出正确的差异数据
                    this.setSubjectSettings({ ...this.backSettingData, ...settingDatas });
                    if (settingDatas.tabstyle) { // 页签模式有改变
                        getWindow().document.title = settingDatas.tabstyle === 'inside' ? 'YonBIP' : langCheck("0000PUB-000148");
                        // 关闭个性化设置
                        if (settingDatas.tabstyle === 'inside') {
                            this.handleBackClick();
                        } else {
                            this.props.rootInstance.forceUpdate();
                        }
                    }
                }
            },
            error: ({ data }) => {
                Notice({ status: "error", msg: data.error && data.error.message });
            },
        });
    }

    getTableStyle = () => {
        const {
            inputdataformat,
            checkedTable,
            crossCheck,
            cuttingCheck,
            rowcheckedButton,
            tablehdbgcolor,
            selectedrowcolor
        } = this.state;
        return {
            tableType: checkedTable,
            crossCheck,
            cuttingCheck,
            rowcheckedButton,
            inputdataformat,
            tablehdbgcolor,
            selectedrowcolor,
        }
    }

    /**
     * 选择事件
     * @param {Object} theme
     */
    checkTheme(theme) {
        const { colorArr } = this.state;
        let { key, pk_customtheme, color, name } = theme;
        this.updateActiveTab('styleSetting');
        if (key === 'custom') { // 自定义主题
            const { styleType } = this.props;
            const customColorArr = colorArr.filter(item => item.styletype === styleType);
            if (customColorArr.length >= 5) {
                toast({
                    content: langCheck('0000PUB-000678'), // 自定义主题数不可以超过5个
                    color: 'danger',
                    container: this.subjectSettingRef
                });
                return;
            }
            const defaultCustomTheme = {
                name: langCheck('0000PUB-000490'), // 自定义
                color: '#BF381A',
            };
            this.setState({
                customTheme: {
                    ...defaultCustomTheme,
                    show: true,
                },
            });
            return;
        }
        if (pk_customtheme) {
            key = colorArr.findIndex(themeItem => themeItem.pk_customtheme === pk_customtheme);
        }

        this.checkItem(key, "colorArr", "checkedColor", pk_customtheme);
        this.setState({
            themeConf: {
                color,
                name,
                pk_customtheme,
            }
        }, () => {
            this.setPreviewTheme();
        })
    }
    /**
     * 选择事件
     * @param {String} key
     * @param {Object} item
     * @param {String} cv
     * @param {String} pk_customtheme 主题主键
     */
    checkItem = (key, item, cv, pk_customtheme) => {
        const { isStyleSetting } = this.state;
        let checkedItem, name;
        this.state[item].forEach(e => {
            e.defaultShow = false;
        });
        this.state[item][key].defaultShow = true;
        if (item === "colorArr") {
            checkedItem = this.state[item][key].color;
            name = this.state[item][key].name;
            // 回写企业风格设置状态
            if (isStyleSetting) {
                const { setCompanyStyleSettingObj, companyStyleSettingObj } = this.props;
                const newCompanyStyleSettingObj = cloneDeep(companyStyleSettingObj);
                const { data } = newCompanyStyleSettingObj;
                data.color = checkedItem;
                data.name = name;
                data.pk_customtheme = pk_customtheme;
                newCompanyStyleSettingObj.data = data;
                setCompanyStyleSettingObj(newCompanyStyleSettingObj);
            }
        } else {
            checkedItem = this.state[item][key].type;
        }
        this.setState({
            [item]: this.state[item],
            [cv]: checkedItem,
        });
    };
    /**
     * 左侧标题区
     * @param {String} name
     * @param {String} icon
     */
     leftAreaTitle = (name, icon, showRight = false) => {
        return (
            <div className='title-area'
            >
                <div className='title-area-l'>
                    {/* {<i className={`${icon} iconfont app-icon`} />} */}
                    {name}
                </div>
                {
                    showRight && <div className='title-area-r'>
                        {/* 需刷新界面后生效 */}
                        {langCheck("0000PUB-000605")}
                    </div>
                }
            </div>
        );
    };
    // 二级标题区
    renderSmallTitle = name => {
        return (
            <div className='title-area title-area-small'>
                <div className='title-area-l'>
                    {name}
                </div>
            </div>
        );
    }
    /**
     * 斑马线/分割线
     * @param {Bool} checked
     * @param {String} key
     */
    switchChange = (checked, key) => {
        this.updateActiveTab('tableSetting');
        this.setState({
            [key]: checked,
        });
    };

    renderWaterMarkSettingModal() {
        const { companyStyleSettingObj, styleType: styletype } = this.props; // styletype 0: 全局；1：集团
        const { data } = companyStyleSettingObj;
        const { pk_group } = data;
        const { watermarkSetting } = this.state;
        const { show, ...rest } = watermarkSetting;
        return (
            <React.Fragment>
                {this.leftAreaTitle(langCheck('0000PUB-000641'), 'icon-shuiyin')}
                <WatermarkSettingPanel
                    styletype={styletype}
                    pk_group={pk_group}
                    multiLangOptions={this.multiLangOptions}
                    watermarkSetting={rest}
                    onChange={this.waterMarkSettingConfirm.bind(this)}
                    ref={node => {this.watermarkPanel = node;}}
                    topContainer={this.subjectSettingRef}
                />
            </React.Fragment>
        );
    }

    handleWatermarkSetting() {
        const { watermarkSetting } = this.state;
        this.origWatermarkSetting = cloneDeep(watermarkSetting);
        this.setState({
            watermarkSetting: {
                ...watermarkSetting,
                show: true,
            },
        });
    }

    waterMarkSettingConfirm(watermarkSetting) {
        this.updateActiveTab('watermarkSetting');
        this.setState({
            watermarkSetting: {
                ...watermarkSetting,
                show: false,
            },
        });
    }

    // 风格设置区域
    getStyleSettingArea = () => {
        const { colorArr, checkedColor, customTheme, allowClick, isStyleSetting } = this.state;
        const { show: themeModalShow, name: themeName, color: selectedColor, pk_customtheme } = customTheme;
        const { permissionArea } = this.props;
        return <React.Fragment>
            {!allowClick && <div className='show-shade' onClick={this.handleShade}></div> /** 无权限时遮罩置灰 */}
            {this.leftAreaTitle(
                langCheck("0000PUB-000396"),
                "icon-fenggeshezhi",
            ) /* 国际化处理： 风格设置*/}
            {permissionArea}
            {
                // 用户级个人中心侧拉可以设置主题，这里不需要
                isStyleSetting && <React.Fragment>
                    <div className="item-block vertical">
                        <div className="item-block-name">{langCheck("0000PUB-000418")}</div>
                        <ThemeColor
                            checkedColor={checkedColor}
                            setSubjectSkin={this.checkTheme.bind(this)}
                            colorArr={colorArr}
                            classNames='subject-skin'
                            type='sebjectSetting'
                            custom
                            handleTheme={this.handleTheme.bind(this)}
                            getPopupContainer={() => this.settingScrollRef.querySelector('.styleSetting')}
                        />
                    </div>
                </React.Fragment>
            }
            {this.getBgSetting()}
            {this.getIconArea()}
            <NCModal
                fieldid="custom-theme"
                dialogClassName='custom-theme-modal'
                show={themeModalShow}
                size='sm'
                resizable={false}
                onHide={this.customThemeCancel.bind(this)}
                container={this.subjectSettingRef}
            >
                <NCModal.Header closeButton>
                    <NCModal.Title>{pk_customtheme ? langCheck('0000PUB-000492' /*编辑主题*/) : langCheck('0000PUB-000491' /*新建主题*/)}</NCModal.Title>
                </NCModal.Header>
                <NCModal.Body className="input-content">
                    <div className="input-item">
                        <label><span className="input-required">*</span>{langCheck('0000PUB-000494') /*主题名称*/}</label>
                        <div className="input-item-content">
                            <NCFormControl fieldid="theme-name" showClose placeholder={langCheck('0000PUB-000493') /*请输入主题名称*/} value={themeName} onChange={value => {
                                this.setState({
                                    customTheme: {
                                        ...customTheme,
                                        name: value,
                                    },
                                });
                            }}></NCFormControl>
                        </div>
                    </div>
                    <div className="input-item">
                        <label>{langCheck('0000PUB-000495') /*主题颜色*/}</label>
                        <ColorPicker
                            className="input-item-content"
                            color={selectedColor}
                            onChange={this.colorPickerConfirm}
                        />
                    </div>
                </NCModal.Body>
                <NCModal.Footer>
                    <NCHotKeys
                        keyMap={{
                            confirmHandle: NCHotKeys.USUAL_KEYS.MODAL_CONFIRM,
                            cancelHandler: NCHotKeys.USUAL_KEYS.MODAL_CANCEL,
                        }}
                        handlers={{
                            confirmHandle: () => { this.customThemeConfirm(); },
                            cancelHandler: () => { this.customThemeCancel(); },
                        }}
                        focused={true}
                    />
                    <NCTooltip
                        overlay={`${langCheck('0000PUB-000001' /* 确定 */)}(${NCHotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                    >
                        <NCButton fieldid="theme-confirm" onClick={() => { this.customThemeConfirm(); }} colors="primary">
                            {langCheck('0000PUB-000001') /*确定*/}
                            (<span className="underline">Y</span>)
                        </NCButton>
                    </NCTooltip>
                    <NCTooltip
                        overlay={`${langCheck('0000PUB-000000' /* 取消 */)}(${NCHotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                    >
                        <NCButton fieldid="theme-cancel" onClick={() => { this.customThemeCancel(); }} colors="secondary">
                            {langCheck("0000PUB-000000") /*取消*/}
                            (<span className="underline">N</span>)
                        </NCButton>
                    </NCTooltip>
                </NCModal.Footer>
            </NCModal>
        </React.Fragment>;
    };
    // 桌面设置区域
    getDesktopSettingArea = () => {
        return <React.Fragment>
            {this.leftAreaTitle(langCheck('0000PUB-000659'), 'icon-zhuomianjianjuicon')}
            {this.getpagewidth()}
            {this.renderCardInterval()}
        </React.Fragment>;
    }
    // 自定义主题取消
    customThemeCancel() {
        const { customTheme } = this.state;
        this.setState({
            customTheme: {
                ...customTheme,
                show: false,
            },
        });
    }
    // 自定义主题确定
    customThemeConfirm() {
        let { customTheme, colorArr } = this.state;
        const { styleType: styletype, companyStyleSettingObj } = this.props;
        const { data: { pk_group } } = companyStyleSettingObj;
        const { name, color, pk_customtheme } = customTheme;
        if (!name) {
            toast({
                content: langCheck('0000PUB-000493'), // 请输入主题名称
                color: 'danger',
                container: this.subjectSettingRef
            });
            return;
        }
        const reg = /[\u4e00-\u9fa5]/g;
        const matchs = name.match(reg);
        const zhCount = matchs && matchs.length || 0;
        const enCount = name.length - zhCount;
        if (enCount + zhCount * 2 > 32) {
            toast({
                content: langCheck('0000PUB-000505'), // 最大录入长度为32(汉字最多录入16个)
                title: langCheck('0000PUB-000506'), // 提示
                color: 'danger',
                container: this.subjectSettingRef
            });
            return;
        }

        const existTheme = colorArr.find(theme => theme.name === name && theme.pk_customtheme !== pk_customtheme);
        if (existTheme) {
            toast({
                content: langCheck('0000PUB-000488'), // 主题名称重复
                color: 'danger',
                container: this.subjectSettingRef
            });
            return;
        }

        let requestData = {
            styletype, // 企业风格类型(0-全局,1-集团）
            pk_group, // 集团主键
            pk_customtheme, // 自定义主题主键
            name,
            color,
        };
        if (styletype == 0) { // 全局不传
            delete requestData.pk_group;
        }
        Ajax({
            toastContainer: this.subjectSettingRef,
            url: "/nccloud/platform/appregister/savecustomtheme.do",
            data: requestData,
            success: ({ data }) => {
                if (data.success) {
                    if (pk_customtheme) {
                        let editTheme = colorArr.find(item => item.pk_customtheme === pk_customtheme);
                        Object.assign(editTheme, data.data);
                        if (editTheme.defaultShow) { // 更新选中主题的预览
                            this.setState({
                                checkedColor: color,
                                themeConf: {
                                    color,
                                    name,
                                    pk_customtheme
                                }
                            }, () => {
                                this.setPreviewTheme();
                            });
                            companyStyleSettingObj.data.color = color;
                        }
                    } else {
                        data.data.editable = true;
                        colorArr = colorArr.concat(data.data);
                        companyStyleSettingObj.data.customColors.push(data.data); // 更新自定义主题数据源
                    }
                    this.setState({
                        customTheme: {
                            ...customTheme,
                            show: false,
                        },
                        colorArr,
                    });
                }
            },
        });
    }
    handleTheme(type, theme) {
        const { pk_customtheme } = theme;
        if (type === 'themeEdit') {
            const { customTheme } = this.state;
            const { name, color } = theme;
            this.setState({
                customTheme: {
                    ...customTheme,
                    name,
                    color,
                    pk_customtheme,
                    show: true,
                },
            });
        }
        if (type === 'themeDelete') {
            const { colorArr } = this.state;
            const { companyStyleSettingObj } = this.props;
            const { data: { customColors } } = companyStyleSettingObj;
            Ajax({
                url: "/nccloud/platform/appregister/delcustomtheme.do",
                data: { pk_customtheme, // 自定义主题主键
                },
                success: ({ data }) => {
                    if (data.success) {
                        remove(colorArr, item => item.pk_customtheme === pk_customtheme);
                        remove(customColors, item => item.pk_customtheme === pk_customtheme); // 更新自定义主题数据源
                        this.setState({ colorArr });
                    }
                },
            });
        }
    }

    // 取色器确定
    colorPickerConfirm = color => {
        const { customTheme } = this.state;
        this.setState({
            customTheme: {
                ...customTheme,
                color,
            },
        });
    }

    // 背景设置
    getBgSetting = () => {
        let { bgColorArr, bgImgArr, isStyleSetting } = this.state;
        let { backgroundState: backgroundObject, companyStyleSettingObj } = this.props;
        if (isStyleSetting) {
            backgroundObject = companyStyleSettingObj.backgroundObject;
        }
        return (
            <BackgroundSetting
                bgImgArr={bgImgArr}
                bgColorArr={bgColorArr}
                getBackgroundObj={this.getBackgroundObjAndAjax}
                getBackgroundObjAndAjax={this.getBackgroundObjAndAjax}
                backgroundObject={backgroundObject}
                bgType='subjectSetting'
                sliderStyle={{ margin: '10px 0 10px 52px' }}
            />
        );

    }
    //获取背景设置返回值并请求接口
    getBackgroundObjAndAjax = value => {
        const { isStyleSetting } = this.state;
        const { changeBgState } = this.props;
        this.updateActiveTab('styleSetting');
        if (isStyleSetting) {
            const { setCompanyStyleSettingObj, companyStyleSettingObj } = this.props;
            let newCompanyStyleSettingObj = cloneDeep(companyStyleSettingObj);
            newCompanyStyleSettingObj.backgroundObject = value;
            setCompanyStyleSettingObj(newCompanyStyleSettingObj);
        } else {
            changeBgState(value); //修改store里面的背景
        }
    }
    // 图标风格
    getIconArea = () => {
        const { iconArr } = this.state;
        return (
            <div className="item-block vertical icon-area">
                <div className="item-block-name">{langCheck("0000PUB-000345")}</div>
                {this.renderUl(iconArr, "iconArr", "checkedIcon", 'icon-panel', 'styleSetting')}
            </div>
        );
    };
    // 桌面宽度
    getpagewidth = () => {
        const { desktopArr, pagewidth } = this.state;
        return (
            <div className="item-block vertical">
                <div className="item-block-name">{langCheck("0000PUB-000410")}</div>
                <NCRadio.RadioGroup
                    name="pagewidth"
                    selectedValue={pagewidth}
                    onChange={this.changeNCRadio.bind(this, 'pagewidth', 'workbenchSetting')}>
                    {
                        desktopArr.map((item => {
                            return this.renderRadioDom(item, 'pagewidth');
                        }))
                    }
                </NCRadio.RadioGroup>
            </div>
        );
    }
    // 卡片间隔
    renderCardInterval = () => {
        const { distance } = this.state;
        const marks = {
            8: '',
            12: '',
            16: '',
            20: '',
            24: '',
        };
        return (
            <div className="item-block vertical">
                <div className="item-block-name">{langCheck("0000PUB-000385")}</div>
                <div className="card-interval-container">
                    <Slider
                        value={cardIntervalFormat(distance)}
                        min={8}
                        max={24}
                        marks={marks}
                        onChange={this.handleCardIntervalChange}
                        tipFormatter={null}
                        step={null}
                        className="subject-setting-slider"
                    />
                    <span className="distance">{cardIntervalFormat(distance)}px</span>
                </div>
            </div>
        );
    }
    // 字体大小设置
    getFontSizeArea = key => {
        const { fontSizeArr, fontSize } = this.state;
        return (
            <div className="item-block vertical font-size-setting">
                <div className="item-block-name">{langCheck("0000PUB-000369")}</div>
                {
                    <NCRadio.RadioGroup
                        name="fontSize"
                        selectedValue={isNumber(fontSize) ? 'custom' : fontSize}
                        onChange={this.changeNCRadio.bind(this, 'fontSize', 'commonSetting')}>
                        {
                            fontSizeArr.map((item => {
                                return this.renderRadioDom(item, 'fontSize');
                            }))
                        }
                    </NCRadio.RadioGroup>
                }
            </div>
        );
    }
    //内部页签开启设置
    getInsideTabsArea = () => {
        const { tabsArr } = this.state;
        return (
            <div className="item-block vertical">
                <div className="item-block-name">{langCheck("0000PUB-000663")}</div>
                {this.renderUl(tabsArr, "tabsArr", "tabstyle", 'inside-tab-panel', 'commonSetting')}
            </div>
        );
    }

    customFontSizeChange = _.debounce((e) => {
        if (isNumber(e)) {
            // 范围 12 - 17
            if (e < 12) { e = 12 }
            if (e > 17) { e = 17 }
            const num = String(e);
            this.setState({
                customFontSize: num
            }, () => {
                this.changeNCRadio('fontSize', 'commonSetting', num);
            });
        }
    }, 300);

    renderRadioDom = (data, type) => {
        const { fieldid, name } = data;
        const typeFieldid = `${type}_${fieldid}`;
        if (type) {
            if (type === 'fontSize' && fieldid === 'custom') {
                const { fontSize, customFontSize } = this.state;
                return <NCRadio className="font-size-custom" fieldid={typeFieldid} value={fieldid}>
                    {name}
                    <NCInputNumber
                        fieldid="font-size-input"
                        className="font-size-input"
                        value={customFontSize}
                        min={12}
                        max={17}
                        step={1}
                        disabled={!isNumber(fontSize)}
                        onChange={this.customFontSizeChange}
                    />
                </NCRadio>;
            }
            return <NCRadio fieldid={typeFieldid} value={fieldid}>{name}</NCRadio>;
        }
        return <div className='nc-radio-item' fieldid={typeFieldid} >
            <img
                onClick={() => { this.changeTableSetting(fieldid); }}
                src={subjectIcons[fieldid]} alt="" />
            <div>
                <NCRadio value={fieldid}>{name}</NCRadio>
            </div>
        </div>;
    }
    // 表格设置
    getTableArea = () => {
        const { crossCheck, cuttingCheck, rowcheckedButton, tableSettingArr, tablehdbgcolor, selectedrowcolor } = this.state;
        const rowcheckBtnArr = [
            {
                fieldid: 'suspension',
                name: langCheck("0000PUB-000456") /**国际化处理： 悬浮显示 */,
            },
            {
                fieldid: 'rowCheckFixed',
                name: langCheck("0000PUB-000455") /** 国际化处理： 固定显示 */,
            },
        ];
        const ncSwitchArr = [
            {
                fieldid: 'crossCheck',
                checked: crossCheck,
                name: langCheck("0000PUB-000354") /**国际化处理： 斑马线 */,
            },
            {
                fieldid: 'cuttingCheck',
                checked: cuttingCheck,
                name: langCheck("0000PUB-000355") /**国际化处理： 纵向分割线 */,
            },
        ];
        const colorDepthArr = [
            {
                fieldid: 'light',
                name: langCheck("0000PUB-000672") /**国际化处理： 浅 */,
            },
            {
                fieldid: 'norm',
                name: langCheck("0000PUB-000352") /**国际化处理： 标准 */,
            },
            {
                fieldid: 'dark',
                name: langCheck("0000PUB-000673") /**国际化处理： 深 */,
            }
        ];
        return (
            <React.Fragment>
                {this.leftAreaTitle(langCheck("0000PUB-000346"), "icon-biaoge2")}
                {/* 行高设置 */}
                <div className="item-block vertical">
                    <div className="item-block-name">{langCheck("0000PUB-000606")}</div>
                    {this.renderUl(tableSettingArr, "tableSettingArr", "checkedTable", 'line-height-panel', 'tableSetting')}
                </div>
                {/* 行操作按钮 */}
                <div className="item-block vertical">
                    <div className="item-block-name">{langCheck("0000PUB-000457")}</div>
                    <NCRadio.RadioGroup
                        name="rowcheckedButton"
                        selectedValue={rowcheckedButton}
                        onChange={this.changeNCRadio.bind(this, 'rowcheckedButton', 'tableSetting')}
                    >
                        {
                            rowcheckBtnArr.map((item => {
                                return this.renderRadioDom(item, 'rowcheckedButton');
                            }))
                        }
                    </NCRadio.RadioGroup>
                </div>
                {/* 表格样式 */}
                <div className="item-block vertical">
                    <div className="item-block-name">{langCheck("0000PUB-000664")}</div>
                    {
                        ncSwitchArr.map(item => {
                            const { fieldid, name, checked } = item;
                            return <NCCheckbox
                                checked={checked}
                                onChange={checked => this.switchChange(checked, fieldid)}
                            >
                                {name}
                            </NCCheckbox>;
                        })
                    }
                </div>
                {/* 表头背景色 */}
                <div className="item-block vertical">
                    <div className="item-block-name">{langCheck("0000PUB-000670")}</div>
                    <NCRadio.RadioGroup
                        name="tableHeadBgColor"
                        selectedValue={tablehdbgcolor}
                        onChange={this.changeNCRadio.bind(this, 'tablehdbgcolor', 'tableSetting')}
                    >
                        {
                            colorDepthArr.map((item => {
                                return this.renderRadioDom(item, 'tablehdbgcolor');
                            }))
                        }
                    </NCRadio.RadioGroup>
                </div>
                {/* 选中行背景色 */}
                <div className="item-block vertical">
                    <div className="item-block-name">{langCheck("0000PUB-000671")}</div>
                    <NCRadio.RadioGroup
                        name="tableSelectedRowColor"
                        selectedValue={selectedrowcolor}
                        onChange={this.changeNCRadio.bind(this, 'selectedrowcolor', 'tableSetting')}
                    >
                        {
                            colorDepthArr.map((item => {
                                return this.renderRadioDom(item, 'selectedrowcolor');
                            }))
                        }
                    </NCRadio.RadioGroup>
                </div>
            </React.Fragment>
        );
    };

    // 表单设置
    getFormArea = () => {
        const { formtitlecolor, formUpdownArr, formUnderlineArr } = this.state;
        return (
            <React.Fragment>
                {this.leftAreaTitle(langCheck("0000PUB-000628"), "icon-biaoge")}
                <div className="item-block vertical">
                    <div className="item-block-name">{langCheck("0000PUB-000629")}</div>
                    {this.renderUl(formUpdownArr, 'formUpdownArr', 'formupdownstyle', 'form-updown-panel', 'formSetting')}
                </div>
                <div className="item-block vertical">
                    <div className="item-block-name">{langCheck("0000PUB-000630")}</div>
                    {this.renderUl(formUnderlineArr, 'formUnderlineArr', 'formunderlinestyle', 'form-underline-panel', 'formSetting')}
                </div>
                {/* 标题颜色 */}
                {/* <div className='item-block'>
                    <div className='item-block-name'>
                        { langCheck('0000PUB-000631') }
                    </div>
                    <ColorPicker
                        className="form-setting-color"
                        color={formtitlecolor}
                        onChange={color => this.setState({
                            formtitlecolor: color,
                        })}
                    />
                </div> */}
            </React.Fragment>
        );
    }

    // 通用render
    renderUl = (data, arrType, checkedType, className = '', tab) => {
        return (
            < ul className={`panel-ul ${className}`}>
                {
                    data.map(item => {
                        let { defaultShow, key, name, type, fieldid, icon } = item;
                        const iconUrl = subjectIcons[icon || type || "defaultIcon"];
                        return (
                            <li
                                className='panel-ul-li'
                                key={key}
                                onClick={() => {
                                    this.updateActiveTab(tab);
                                    this.checkItem(key, arrType, checkedType)
                                }}
                                fieldid={fieldid}
                            >
                                <div className={defaultShow ? "select-bg li-top" : "li-top"}>
                                    <div className="li-top-bg" style={{
                                        background: `url(${iconUrl}) no-repeat center center`,
                                        backgroundSize: "contain"
                                    }}>
                                        {defaultShow &&
                                            <img
                                                className="select-icon"
                                                src={selectIcon} alt="" />
                                        }
                                    </div>
                                </div>
                                <span className={`name ${defaultShow ? 'name-select' : ''}`}>{name}</span>
                            </li>
                        );
                    })
                }
            </ul >
        );
    }
    // radio 操作
    changeNCRadio = (key, tab, value) => {
        this.updateActiveTab(tab);
        if (key === 'fontSize') {
            if (value === 'custom') {
                const { customFontSize } = this.state;
                value = customFontSize;
            }
            setNccFontSize(value, this.subjectSettingRef.querySelector('.previewPic'), false);
        }
        this.setState({ [key]: value }, () => {
            if (['tablehdbgcolor', 'selectedrowcolor'].includes(key)) {
                this.setPreviewTheme();
            }
        });
    }
    handleBackClick = () => {
        // 返回首页
        this.props.history.push(`/`);
    }

    handdleRefChange = (value, foolValue) => {
        const { companyStyleSettingObj, getGroupData } = this.props;
        let foolValueNew = foolValue;
        if (!foolValue.display && !foolValue.value) {
            /* "集团参照不能为空"  */
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000611'),
            });
            foolValueNew = companyStyleSettingObj.foolValue;
        }
        getGroupData(foolValueNew.value, foolValueNew);
    }
    handleShade = () => {
        Notice({
            status: "warning",
            msg: langCheck('0000PUB-000416'), //多语-全局或集团已统一设置，不支持修改
        });
    }

    //卡片间隔change
    handleCardIntervalChange = value => {
        this.updateActiveTab('workbenchSetting');
        this.setState({ distance: value });
    }

    // 预览查询区
    renderSearchArea = () => {
        let { search, button } = this.props;
        const { createButtonApp } = button;
        let { NCCreateSearch } = search;
        return <div className='search-area-box'>
            <div className='title-box'>
                <div className='title-left'>
                    { this.renderAppIcon() }
                    <NCDiv className='title'>
                        {langCheck("0000PUB-000584")}
                    </NCDiv>
                </div>
                {createButtonApp({
                    area: 'general_btn',
                    buttonLimit: 3,
                })}
            </div>
            <div className='search-area'>
                {
                    NCCreateSearch(searchId, {
                        hideBtnArea: true,
                        showSearchLable: false,
                        ...this.getFormStyle()
                    })
                }
            </div>
        </div>;
    }

    renderFormArea = () => {
        const { form } = this.props;
        return <div className="preview-form-area">
            {form.createForm(formId, this.getFormStyle())}
        </div>
    }

    getFormStyle = () => {
        const { formunderlinestyle, formupdownstyle } = this.state;
        return {
            underlineBorder: formunderlinestyle,
            formLayout: formupdownstyle ? 'top' : 'left'
        }
    }

    renderTableArea = () => {
        const { table } = this.props;
        return <div className="preview-table-area">
            {
                table.createSimpleTable(tableId, {
                    adaptionHeight: true,
                    // height: 240,
                    showCheck: true,
                    showPagination: false,
                    customSetting: this.getTableStyle()
                })
            }
        </div>
    }

    // 渲染导航栏
    renderNavBar= () => {
        const { companyStyleSettingObj } = this.props;
        const { isStyleSetting, checkedColor, tabstyle, nvigapic } = this.state;
        const navConfig = {
            theme: {
                type: colorMap[checkedColor] || 'mixin',
                color: checkedColor
            }, 
            logo: isStyleSetting ? companyStyleSettingObj.data.nvigapic : nvigapic,
        };
        return <React.Fragment>
            {/* 导航栏 */}
            <div className={`nc-workbench-top-container nccwb-top`}>
                <NavBar ispreview navConfig={navConfig} />
            </div>

            {/* 模拟内部页签栏的dom，后续可优化，抽成组件这里直接用 */}
            {
                tabstyle === 'inside' && <div className="inside-tabs-nav">
                    <span className={`home-actived tab0 tab-common`}>
                        <span className="tab-home-content tab-text">
                            <i className="icon iconfont icon-shouye home-icon" />
                            {langCheck('0000PUB-000105')}
                        </span>
                    </span>
                    <div className="tab-left"></div>
                    <div className="tab-right">
                        <span className="drop-down-container">
                            <img className="drop-down" src={dropIcon} />
                        </span>
                        <i className="right-item icon iconfont icon-zhuomianpeizhi" />
                        <i className="right-item icon iconfont icon-yincangdaohang nav-icon" />
                        <i className="right-item icon iconfont icon-quanpingliulan" />
                    </div>
                </div>
            }
        </React.Fragment>
    }

    renderGridLayout = () => {
        let { distance, pagewidth, isStyleSetting, themeConf, checkedIcon } = this.state;
        const { companyStyleSettingObj } = this.props;
        const group = getDesktopPreviewData();
        initDesktopApp([group]); // 这里理应是直接构造完整数据，不需要去init
        const containerPadding = pagewidth === 'adaptive' ? [20, 10] : [40, 10];
        let backgroundObject; // 工作台背景
        let themeColor;
        if (!isStyleSetting) { // 个性化设置
            themeColor = themeConf.color;
            backgroundObject = this.props.backgroundState;
        } else { // 企业风格设置
            const { data = { color: '' } } = companyStyleSettingObj;
            themeColor = data.color;
            backgroundObject = companyStyleSettingObj.backgroundObject;
        }
        themeColor = colorMap[themeColor] || 'mixin';
        let previewClass = '';
        if (isStyleSetting && themeColor !== 'black') {
            // 这个类名日程管理小部件预览时有用到，适用于工作桌面是暗黑，预览区非暗黑的情况
            previewClass = 'subject-setting-preview';
        }
        const bgStyle = getBackgroundStyle(backgroundObject, themeColor);
        return <SizeMe>
            {
                ({ size }) => <div className={`preview-box nc-workbench-home-container ${previewClass}`}>
                    <div className="preview-bg-container">
                        <div className='preview-bg-img' style={bgStyle}></div>
                    </div>
                    {
                        group && size.width && <GridLayout
                            key={group.pk_app_group}
                            apps={group.apps}
                            groupId={group.pk_app_group}
                            groupItem={group}
                            groupIndex={1}
                            margin={+cardIntervalFormat(distance)}
                            col={GRID_COLS}
                            gridContainerPadding={containerPadding}
                            size={{ width: size.width / this.previewScale }} // 弥补预览区缩放导致的全挤在一起
                            isDroppable={false}
                            relateidObj={{
                                data: "",
                                code: "1",
                                type: "userID",
                            }}
                            themeColor={themeColor}
                            iconType={checkedIcon}
                        />
                    }
                </div>
            }
        </SizeMe>
    }

    // 计算最后一项的下边距，为了能让ScrollLink滚动激活
    getItemAreaStyle = () => {
        const scrollContainerHeight = this.settingScrollRef.getBoundingClientRect().height;
        const allArea = this.settingScrollRef.querySelectorAll('.itemArea');
        const lastArea = allArea[allArea.length - 1];
        const lastContainerHeight = lastArea.getBoundingClientRect().height;
        if (lastContainerHeight < scrollContainerHeight) {
            // 容器高度向上取整，目标高度向下取整，尽量计算的下边距偏大，这样才能保证滚动到位
            lastArea.style.paddingBottom = `${Math.ceil(scrollContainerHeight) - Math.floor(lastContainerHeight) + scrollLinkOffset}px`;
        }
    }

    // 防抖，避免切换过程中右侧预览区闪动
    handleLinkActive = _.debounce((to) => {
        this.updateActiveTab(to.split('-').shift());
    }, 150);

    handleScrollLinkClick = _.debounce((e, key, index) => {
        const { activeTab } = this.state;
        if (activeTab === key) { return; }

        const scrollContainerRect = this.settingScrollRef.getBoundingClientRect();
        const targetRect = this.settingScrollRef.querySelector(`[name=${key}-${this.instantiationKey}]`).getBoundingClientRect();
        const startTime = Date.now();
        const { scrollTop } = this.settingScrollRef;
        const distanceY = targetRect.top - scrollContainerRect.top + scrollLinkOffset;
        const scrollFunc = () => {
            const pastTime = Date.now() - startTime;
            const process = Math.min(pastTime / scrollLinkDuration, 1);
            if (process < 1) {
                window.requestAnimationFrame(scrollFunc);
            }
            let targetScrollTop = scrollTop + distanceY * process;
            if (process === 1) {
                if (index === 0) {
                    targetScrollTop = 0;
                } else {
                    targetScrollTop += 1; // 加1，浏览器缩放之后，会导致计算出小数，必须保证滚动到位
                }
                this.updateActiveTab(key);
            }
            this.settingScrollRef.scrollTop = targetScrollTop;
        }
        window.requestAnimationFrame(scrollFunc);
    }, scrollLinkDuration + 50)


    renderAppIcon() {
        const { c } = GetQuery(window.location.hash);
        return <Appicon appCode={c} iconName={c ? "" : "yewushezhilei1"} />;
    }

    render() {
        let { isStyleSetting, activeTab } = this.state;
        let { title, logoArea, companyStyleSettingObj, styleType, hideBackBtn } = this.props;
        let foolValue = {};
        if (companyStyleSettingObj && companyStyleSettingObj.foolValue) {
            foolValue = companyStyleSettingObj.foolValue;
        }
        const pageTitle = isStyleSetting ? title : langCheck("0000PUB-000148");
        let allTabs = [
            {
                key: 'styleSetting',
                name: langCheck("0000PUB-000396"), // 风格设置
                content: this.getStyleSettingArea(),
                icon: 'icon-fenggeshezhi'
            },
            {
                key: 'commonSetting',
                name: langCheck("0000PUB-000658"), // 通用设置
                content: <React.Fragment>
                    {this.leftAreaTitle(langCheck("0000PUB-000658"), "icon-zhuomianshezhi", true)}
                    {this.getFontSizeArea('fontSize')}
                    {this.getInsideTabsArea()}
                </React.Fragment>,
                icon: 'icon-zhuomianshezhi'
            },
            {
                key: 'formSetting',
                name: langCheck("0000PUB-000628"), // 表单设置
                content: this.getFormArea(),
                icon: 'icon-biaoge'
            },
            {
                key: 'tableSetting',
                name: langCheck("0000PUB-000346"), // 表格设置
                content: this.getTableArea(),
                icon: 'icon-biaoge2'
            },
            {
                key: 'workbenchSetting',
                name: langCheck("0000PUB-000659"), // 工作台设置
                content: this.getDesktopSettingArea(),
                icon: 'icon-zhuomianjianjuicon'
            },
        ];
        if (styleType == 0) {
            allTabs.unshift({
                key: 'globalSetting',
                name: langCheck("0000PUB-000604"), // 全局设置
                content: logoArea,
                icon: 'icon-yeqianshezhi'
            })
        }
        isStyleSetting && allTabs.push({
            key: 'watermarkSetting',
            name: langCheck("0000PUB-000641"), // 水印设置
            content: this.renderWaterMarkSettingModal(),
            icon: 'icon-shuiyin'
        })
        const previewHome = ['globalSetting', 'styleSetting', 'workbenchSetting'].includes(activeTab);
        return (
            <PageLayout
                onRef={ref => this.subjectSettingRef = ref}
                className={`subjectsetting-layout subjectsetting-${this.instantiationKey}`}
                header={
                    <PageLayoutHeader pageback={this.handleBackClick}>
                        <div className='pageLayoutHeaderOwn'>
                            {
                                !hideBackBtn && <NCTooltip
                                    className="app-tooltip"
                                    placement='bottom'
                                    overlay={langCheck("0000PUB-000468")}
                                    /** 返回 */
                                    trigger='hover'
                                    delayShow={500}
                                    delay={1}
                                >
                                    <i className='iconfont icon-danjufanhuiicon' onClick={this.handleBackClick} />
                                </NCTooltip>
                            }
                            { this.renderAppIcon() }
                            <NCDiv
                                fieldid={pageTitle}
                                areaCode={NCDiv.config.Title}
                                className="workbench-page-title"
                            >
                                {pageTitle}
                                {
                                    !isStyleSetting && <NCTooltip
                                        placement="bottom"
                                        overlay={langCheck('0000PUB-000676')}
                                    >
                                        <i className="iconfont icon-shuoming1 title-help-icon"></i>
                                    </NCTooltip>
                                }
                            </NCDiv>
                            {title === langCheck("0000PUB-000393") &&
                                <ReferLoader
                                    refcode="uap/refer/riart/groupTreeRef/index"
                                    foolValue={foolValue}
                                    onChange={this.handdleRefChange}
                                    fieldid="profitcostregion"
                                    queryCondition={
                                        () => {
                                            return { isNeedFilter: true };
                                        }
                                    }
                                />}   {/** title为企业风格设置-集团时  显示集团参照 */}
                        </div>

                    </PageLayoutHeader>
                }>
                <div className='subjectSetting'>
                    <div className='subjectSettingContent'>
                        <NCDiv
                            className='subjectSettingLeft'
                            fieldid='left'
                            areaCode={NCDiv.config.Area}
                        >
                            <div className="anchor-link-container">
                                <div className="anchor-scroll-link" ref={ref => this.scrollLinkRef = ref}>
                                    {allTabs.map((tab, index) => {
                                        return (
                                            <Link
                                                tabid={tab.key}
                                                to={`${tab.key}-${this.instantiationKey}`}
                                                spy={true}
                                                smooth={true}
                                                duration={scrollLinkDuration}
                                                activeClass={scrollLinkActiveClass}
                                                containerId={`anchor-scroll-container-${this.instantiationKey}`}
                                                className="link-item"
                                                offset={scrollLinkOffset}
                                                onSetActive={this.handleLinkActive}
                                                // 阻止原有的滚动，有bug，自行触发
                                                // onClick={e => { this.handleScrollLinkClick(e, tab.key) }}
                                                onClickCapture={e => {
                                                    e.stopPropagation();
                                                    this.handleScrollLinkClick(e, tab.key, index);
                                                }}
                                            >
                                                <div className="link-icon-container">
                                                    <i className={`iconfont link-icon ${tab.icon}`}></i>
                                                </div>
                                                <span className="link-name">{tab.name}</span>
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                            <div ref={ref => this.settingScrollRef = ref} className="anchor-scroll-container" id={`anchor-scroll-container-${this.instantiationKey}`}>
                                {allTabs.map(tab => {
                                    return (
                                        <Element name={`${tab.key}-${this.instantiationKey}`} className={`itemArea ${tab.key} ${tab.key === activeTab ? scrollLinkActiveClass : ''}`}>
                                            {tab.content}
                                        </Element>
                                    );
                                })}
                            </div>
                        </NCDiv>
                        <div className='subjectSettingRight'>
                            {
                                // previewPic 这个类有用（设置预览主题需要获取这个元素），不要删
                                <div
                                    ref={ref => this.previewRef = ref}
                                    className={`previewPic`}
                                    onClickCapture={e => e.stopPropagation()} // 预览禁止点击事件
                                >
                                    {this.renderNavBar()}
                                    <Watermark
                                        className="preview-body"
                                        style={{
                                            overflow: 'auto'
                                        }}
                                        multiLangOptions={this.multiLangOptions}
                                        watermarkSetting={this.state.watermarkSetting}
                                    >
                                        {/* 首页 */}
                                        <div className="preview-content" style={{ display: previewHome ? 'block' : 'none' }}>
                                            {this.renderGridLayout()}
                                        </div>

                                        {/* 节点 */}
                                        <div className="preview-content" style={{ display: previewHome ? 'none' : 'flex', flexDirection: 'column' }}>
                                            {this.renderSearchArea()}
                                            {/* 表格预览不展示表单 */}
                                            {activeTab !== 'tableSetting' && this.renderFormArea()}
                                            {/* 表单预览不展示表格 */}
                                            {activeTab !== 'formSetting' && this.renderTableArea()}
                                        </div>
                                    </Watermark>
                                </div>
                            }
                        </div>
                    </div>
                    <NCDiv className='default-footer' areaCode={NCDiv.config.BOTTOM}>
                        <NCButton
                            colors='primary'
                            onClick={this.onApply.bind(this)}
                            fieldid='apply'>
                            {langCheck("0000PUB-000384") /* 国际化处理： 应用*/}
                        </NCButton>
                    </NCDiv>
                </div >
            </PageLayout >
        );
    }
}

SubjectSetting = withRouter(
    connect(
        state => ({
            backgroundState: state.appData.backgroundState, // 背景设置
            globalTheme: state.appData.theme
        }),
        {
            setNccFont,
            changeBgState,
        },
    )(SubjectSetting),
);
export default createPage({ initTemplate })(withDragDropContext(SubjectSetting));